import { TypeCertificateService } from "@common/client"
import { makeQuery } from "./utils"

export const aircraftTypeQuery = makeQuery({
  serviceCall: TypeCertificateService.listGrouped,
  queryKey: (input) => ["type-certificates", input?.with_work_history ?? false],
})
